var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{staticClass:"custom-image",attrs:{"image":"/static/img/pro/no-data.png","description":_vm.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }